import Cookies from "js-cookie";
import moment from "moment";

export const isAuthenticated = (): boolean => {
  // const cookies = new Cookies();

  try {
    const user = Cookies.get("@onsidetech_current_user");

    if (user) {
      const data: any = JSON.parse(user);

      if (data) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const getToken = (): string => {
  if (isAuthenticated()) {
    const user = Cookies.get("@onsidetech_current_user");

    if (user) {
      return 'token';
    } else return "";
  } else {
    return "";
  }
};

export const getId = (): string | number => {
  if (isAuthenticated()) {
    const user = Cookies.get("@onsidetech_current_user");

    if (user) {
      const data: any = JSON.parse(user);

      return data?.id ?? "";
    } else return "";
  } else {
    return "";
  }
};

export const getUser = (): iUserLogged | undefined => {
  if (isAuthenticated()) {
    const user = Cookies.get("@onsidetech_current_user");
    if (user) return JSON.parse(user);
  }

  return undefined;
};

export const login = (params: any): boolean => {
  try {
    Cookies.set(
      "@onsidetech_current_user", 
      JSON.stringify(params), 
      // { expires: moment(params.token_expires_at).utc(true).toDate() },
    );

    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const logout = (): boolean => {
  console.log('logout?');
  Cookies.remove("@onsidetech_current_user");

  return true;
};
